import { GlucoseUnit } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useGetGlucoseValue } from "./useGetGlucoseValue"
import { usePolyglot } from "src/contexts"
import { useGlucoseUnit } from "src/hooks/account"
import { round } from "src/utils"

/*
 * returns a function that returns the glucose value
 * in a readable scaled and rounded string
 */
export function useDisplayGlucoseValue(): (value: number) => string {
  const polyglot = usePolyglot()
  const glucoseUnit = useGlucoseUnit()
  const getGlucoseValue = useGetGlucoseValue()


  return useCallback(
    (value: number) => {
      const scaledValue = getGlucoseValue(value)

      if (glucoseUnit === GlucoseUnit.MillimolesPerLiter) {
        const roundedValue = round(
          scaledValue,
          1,
        )

        return roundedValue.toLocaleString(
          polyglot.locale(),
          { minimumFractionDigits: 1 },
        )
      }

      return round(scaledValue).toLocaleString(polyglot.locale())
    },
    [
      getGlucoseValue,
      glucoseUnit,
      polyglot,
    ],
  )
}
